import React, { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from "@remix-run/react";
import { ActionTitle } from './ActionTitle';
import { Container } from './TopicPage.styles';
import { useTopicSections } from './use-topic-sections';
import SvgFavorite from '../../../../play-core/icons/Favorite';
import SvgFavoriteOutline from '../../../../play-core/icons/FavoriteOutline';
import { toSeoString } from '../../../../play-core/utils/to-seo-string';
import { PageNotFound } from '../../../src/pages/Error/PageNotFound';
import { VerticalScrollTracker } from '../../analytics/VerticalScrollTracker';
import { ErrorIfEmpty } from '../../components/Message/ErrorIfEmpty';
import { Sections } from '../../components/Section/Sections';
import { useVideoConfig } from '../../config/VideoAppContext';
import { useDataDispatch, useTopicState } from '../../providers/DataProvider/DataContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TopicPage = ({
  initialData
}) => {
  const {
    favoritesSupported
  } = useVideoConfig();
  const {
    t
  } = useTranslation();
  const {
    topicName
  } = useParams();
  const {
    userTopics,
    isTopicsLoading
  } = useTopicState();
  const dispatch = useDataDispatch();
  const topic = useMemo(() => {
    if (topicName) {
      return userTopics.find(top => toSeoString(top.title) === topicName);
    }
  }, [topicName, userTopics]);
  const {
    topicSections,
    isLoading
  } = useTopicSections(initialData, topic);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [topic && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(VerticalScrollTracker, {
        pageTitle: `Topic-${topic.title}`
      }), /*#__PURE__*/_jsx(Container, {
        topicUrn: topic.urn,
        children: /*#__PURE__*/_jsx(ActionTitle, {
          title: topic.title,
          onAction: () => dispatch({
            type: 'toggle-topic-favorite',
            topicId: topic.id,
            showSnackbar: true
          }),
          activeIcon: /*#__PURE__*/_jsx(SvgFavorite, {}),
          ariaIconTitle: t('global.favor'),
          inactiveIcon: /*#__PURE__*/_jsx(SvgFavoriteOutline, {}),
          isActive: topic.isFavorite,
          showAction: favoritesSupported
        })
      }), /*#__PURE__*/_jsx(ErrorIfEmpty, {
        isLoading: isLoading,
        children: /*#__PURE__*/_jsx(Sections, {
          initialData: initialData,
          sections: topicSections
        })
      })]
    }), !topic && !isTopicsLoading && /*#__PURE__*/_jsx(PageNotFound, {})]
  });
};